import React from 'react';
import { /*Redirect,*/ Route } from 'react-router-dom';
//import { isAuthenticated, } from './AuthenticationUtil';

export const ProtectedRoute = (props) => {
    //return isAuthenticated() ? <Route {...props} /> : <Redirect to="/login" />;
    return <Route {...props} />;
};